import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { Button } from '@mui/material';
import { useResourceContext } from 'react-admin';
import { Link } from 'react-router-dom';

/**
 * "Back to the list", top left, where a back control belongs.
 *
 * react-admin's own ListButton sits in the top toolbar, which is right
 * aligned next to the record's actions - so the way out of a screen ended up
 * in the same corner as the things that change it. This is the same
 * destination with a back arrow, on the left.
 *
 * It links rather than calling history.back(): each tab of a tabbed form is
 * its own history entry, so going back from the fourth tab would take four
 * presses. react-admin keeps each list's filters and page in its store, so the
 * list still comes back as it was left.
 */
export function BackLink({ label = 'Späť na zoznam' }: { label?: string }) {
  const resource = useResourceContext();
  if (resource == null) return null;

  return (
    <Button
      component={Link}
      to={`/${resource}`}
      startIcon={<ArrowBackIcon />}
      size="small"
      color="inherit"
      sx={{ alignSelf: 'flex-start', textTransform: 'none' }}
    >
      {label}
    </Button>
  );
}
